import { createSlice } from "@reduxjs/toolkit"

export const dagsSlice = createSlice({
  name: "dags",
  initialState: {
    dags: [],
    selectedDagId: null,
  },
  reducers: {
    addDags: (state, action) => {
      state.dags = action.payload?.dags || action.payload
    },
    setSelectedDagId: (state, action) => {
      state.selectedDagId = action.payload
    },
  },
})

export const { addDags, setSelectedDagId } = dagsSlice.actions

export default dagsSlice.reducer
